var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglesignin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #ea4335;\r\n      }\r\n\r\n      .cls-2, .cls-3, .cls-4, .cls-5 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fbbc05;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #4285f4;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #34a853;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Google-Button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn_google_light_normal",
    "data-name": "btn google light normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button-bg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    className: "cls-1",
    width: 40,
    height: 40,
    rx: 2,
    ry: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo_googleg_48dp",
    "data-name": "logo googleg 48dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-4",
    d: "M28.64,20.2c0-.64-.06-1.25-.16-1.84h-8.48v3.48h4.84c-.21,1.12-.84,2.08-1.8,2.72v2.26h2.91c1.7-1.57,2.68-3.87,2.68-6.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-5",
    d: "M20,29c2.43,0,4.47-.81,5.96-2.18l-2.91-2.26c-.81,.54-1.84,.86-3.05,.86-2.34,0-4.33-1.58-5.04-3.71h-3.01v2.33c1.48,2.94,4.52,4.96,8.04,4.96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    className: "cls-3",
    d: "M14.96,21.71c-.18-.54-.28-1.12-.28-1.71s.1-1.17,.28-1.71v-2.33h-3.01c-.61,1.22-.96,2.59-.96,4.04s.35,2.83,.96,4.04l3.01-2.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    className: "cls-2",
    d: "M20,14.58c1.32,0,2.51,.45,3.44,1.35l2.58-2.58c-1.56-1.45-3.6-2.34-6.02-2.34-3.52,0-6.56,2.02-8.04,4.96l3.01,2.33c.71-2.13,2.69-3.71,5.04-3.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    className: "cls-6",
    d: "M11,11H29V29H11V11Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglesignin);
export default __webpack_public_path__ + "static/media/googlesignin.cb9e0ae42b778c5230e4c4d86304162d.svg";
export { ForwardRef as ReactComponent };